export const areAllDigitsTheSame = (value: string): boolean =>
  value.split('').every((c) => c === value[0]);
